export const queryString = (params) => Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');